module.exports = __webpack_public_path__ + "static/media/plant.77eacf16.svg";